import { render } from "./modify-inventory.vue?vue&type=template&id=0a074c98"
import script from "./modify-inventory.vue?vue&type=script&lang=js"
export * from "./modify-inventory.vue?vue&type=script&lang=js"

import "./modify-inventory.vue?vue&type=style&index=0&id=0a074c98&lang=scss"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__